import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "components/Elements/Dropdown";
import { TimezoneOptions } from "constants/reportSubscriptions";
import FieldLabel from "./FieldLabel";

const TimezoneField = ({ value, onChange, label, required = false }) => {
	const { t } = useTranslation();
	const selected = useMemo(
		() => TimezoneOptions.find((o) => o.value === value) || {},
		[value]
	);

	return (
		<div>
			<FieldLabel required={required}>{label || t("label.timezone")}</FieldLabel>
			<Dropdown
				options={TimezoneOptions}
				selectedValue={selected}
				onChange={(opt) => onChange(opt.value)}
				placeholder={t("placeholder.selectTimezone")}
				width="100%"
			/>
		</div>
	);
};

export default TimezoneField;
